module.exports = __webpack_public_path__ + "img/Products_Desktop_11.a1a95584.jpg";